import React, { FC, useContext, useState } from 'react'
import { LookBookDetailContext } from '../../../contexts/lookbookDetailProvider'
import Button from '../../common/Button/Button'
import Title from '../../common/Title/Title'
import Link from 'next/link'
import Image from '../../common/Image/Image'

import { ButtonTheme } from '../../types'
import css from './LookBookDetail.module.scss'
import { CartContext } from '../../../contexts/cart'
import ym from 'react-yandex-metrika'
import { trackVKPurchaseGoal } from '../../../lib/trackVKPurchaseGoal'

const LookBookDetail: FC = () => {
  const [added, setAdded] = useState(false)
  const { addSet, loading } = useContext(CartContext)
  const { itemData } = useContext(LookBookDetailContext)
  const totalPrice = itemData.structure.reduce((prev, item) => {
    return prev + item.price
  }, 0)
  const totalPriceOld = itemData.structure.reduce((prev, item) => {
    return prev + item.priceOld
  }, 0)
  const setIds = itemData.structure.map(({ id }) => id)

  return (
    <section className={css.wrapper}>
      <div className={css.details}>
        <div className={css.top}>
          <Link href="/lookbook" passHref>
            <a className="brown-link">← LookBook</a>
          </Link>
          <Title className={css.heading}>{itemData.name}</Title>
        </div>

        <ul className={css.list}>
          {itemData.structure.map((product) => (
            <li key={product.id} className={css.list_item}>
              <Link href={product.link} passHref>
                <a className={css.link}>
                  <div className={css.nameWrapper}>
                    <p className={css.name}>{product.name}</p>
                    {product?.subName && (
                      <p className={css.skuName}>{product.subName}</p>
                    )}
                  </div>
                  <div className={css.priceWrapper}>
                    {product?.priceOld !== product.price && (
                      <p className={css.priceOld}>{product.priceOld} ₽</p>
                    )}
                    <p className={css.price}>{product.price} ₽</p>
                  </div>
                </a>
              </Link>
            </li>
          ))}
        </ul>

        <div className={css.total}>
          <Button
            title="Добавить в корзину"
            theme={ButtonTheme.black}
            className={css.button_wrapper}
            onClick={() => {
              setAdded(true)
              ym('reachGoal', 'km_add_to_cart_from_detail_page')

              trackVKPurchaseGoal('add_to_cart')

              addSet(
                itemData.id,
                setIds,
                itemData?.structure?.map((el) => ({
                  name: el.subName ? `${el.name} ${el.subName}` : el.name,
                  id: el.bx_id,
                  price: totalPrice,
                  category: 'Lookbook',
                  quantity: 1,
                })),
                1,
              )
            }}
            loading={loading}
          >
            {added ? 'Добавить еще' : 'Добавить в корзину'}
          </Button>
          <div className={css.price_wrapper}>
            <p className={css.total_heading}>Цена набора:</p>
            {totalPriceOld !== totalPrice && (
              <p className={css.total_priceOld}>{totalPriceOld} ₽</p>
            )}

            <p className={css.total_price}>{totalPrice} ₽</p>
          </div>
        </div>
      </div>

      <div className={css.cover}>
        <Image
          width={640}
          height={875}
          src={itemData.img}
          alt={itemData.name}
          loading="eager"
          layout="responsive"
          objectFit="cover"
          priority
        />
      </div>

      <div className={css.top_mobile}>
        <Link href="/lookbook" passHref>
          <a className="brown-link">← LookBook</a>
        </Link>
        <Title className={css.heading}>{itemData.name}</Title>
      </div>
    </section>
  )
}

export default LookBookDetail
